export function hasPositiveValue(value: number | null | undefined): value is number {
  return typeof value === 'number' && value > 0;
}
